<template>
    <div>        
        <div v-if="weekTimeRegular == 0" class="noContract">
                kein Arbeitsvertrag
        </div>
        <div v-if="weekTimeRegular > 0">

            <div style="margin-top:-12px; padding-top: 0px; height: 30px; overflow:hidden;" v-bind:style="{ width: (indentationLevel == 0 ? widthIndentation0+'px' : widthIndentation1+'px')}">
                
                
                <!-- Gray Background Bar -->
                <div style="margin-top:18px; height:12px;   background-color: rgb(229,229,229); border-radius: 20px; border:1px solid #fff;" 
                    v-bind:style="{ width: (indentationLevel == 0 ? (red_overtime_width > 0 ? (widthIndentation0Calc+red_overtime_width)+'px' : widthIndentation0Calc+'px') : (red_overtime_width > 0 ? (widthIndentation1Calc+red_overtime_width)+'px' : widthIndentation1Calc+'px'))}"></div>
                <div style="margin-top:-30px; height:0px;"></div>
                <!-- Gray Background Bar END -->

                <!-- TEXT -->
                <div style="margin-top:4px; height:14px; margin-left:0px; line-height: 14px; text-align: right; color:var(--contrast-4); font-size: 10px; padding-right: 5px;"
                v-bind:style="{ width: (indentationLevel == 0 ? widthIndentation0+'px' : widthIndentation1+'px')}">{{availablePlantimeInHours}}</div>
                <div style="margin-top:-18px; height:0px;"></div>
                <!-- TEXT END -->

                <!-- Alle Plan Zeiten -->
                <div style="margin-top:19px; height:10px; background-color: rgb(178,178,178); border-radius:20px;" v-bind:style="{'margin-left':'1px', width: summAllWidth+'px'}"></div>
                <div style="margin-top:-29px; height:0px;"></div>


                <!-- Red overtime #e5154f -->
                <div v-if="red_overtime_width > 0" 
                    style="margin-top:18px; height:12px;   background-color: #e5154f; border:1px solid #fff; border-top-right-radius:20px; border-bottom-right-radius:20px;" 
                    v-bind:style="{'margin-left':(indentationLevel == 0 ? (widthIndentation0Calc-1)+'px' : (widthIndentation1Calc-1)+'px'),  width: (red_overtime_width+1)+'px'}">
                </div>

            </div>

            <div style="height: 10px; margin-top:-11px; border-right:1px solid #000;" v-bind:style="{display: (overflow < 1 ? 'block' : 'none'), width: (indentationLevel == 0 ? widthIndentation0Calc+'px' : widthIndentation1Calc+'px')}"></div>
        </div>
            




    </div>
</template>
<script>
    export default {
        name: 'sollistbars',
        components: {
        },
        data(){
            return{
                widthIndentation0 : 185,
                widthIndentation1 : 165,

                widthIndentation0Calc : 185,
                widthIndentation1Calc : 165,

                weekTimeRegular : 0,
                weekTimeRegularInHours : 0,

                availablePlantime : 0,
                availablePlantimeInHours : 0,

                oneMinuteInPixel: 0.0,
                overflow: 1,

                summAllWidth : 0,
                summAll : 0,
            }
        },
        props:{
            indentationLevel: Number,
            employeeId: null,
        },

        watch: {
        },

        created () {
            this.update();
        },
        destroyed(){
        },
        methods: {
            update: function(){
                this.widthIndentation0Calc = this.widthIndentation0 * this.$parent.sollIstOverflow;
                this.widthIndentation1Calc = this.widthIndentation1 * this.$parent.sollIstOverflow;

                this.summAll = 0;
                let employee = this.$parent.employeeMap[this.employeeId];
                if(employee != null && employee != undefined){
                    //console.log(employee.firstName + " " + employee.lastName);

                    this.weekTimeRegular = employee.si_weekTimeRegular; // 10400
                    this.overflow = employee.si_overflow;
                    if(this.weekTimeRegular > 0){

                        this.weekTimeRegularInHours = Math.floor(this.weekTimeRegular / 60); // Actually, this are the hours this employee has to work per month
                        this.availablePlantime = this.weekTimeRegular;

                        if(this.indentationLevel == 0){
                            this.oneMinuteInPixel = this.widthIndentation0 / this.weekTimeRegular * this.$parent.sollIstOverflow;// Calculate one Minute in Pixels
                        }else{
                            this.oneMinuteInPixel = this.widthIndentation1 / this.weekTimeRegular * this.$parent.sollIstOverflow;// Calculate one Minute in Pixels
                        }


                        // IST Zeiten
                        if(this.$parent.sollIstMode == 0){
                           this.summAll = this.summAll + employee.si_workTimeBalance;//minutes 
                        }

                        // PLAN Zeiten
                        this.summAll = this.summAll + employee.si_sumPlanned;//minutes
                        
                        //console.log("PLAN Summe : ");
                        //console.log(this.summAll);

                        //console.log("Krank Summe : ");
                        // Krank Zeiten
                        this.summAll = this.summAll + Math.floor(employee.si_sumSickness);//minutes
                        //console.log(this.summAll);

                        //console.log("Urlaub Summe : ");
                        // Urlaub Zeiten
                        this.summAll = this.summAll + Math.floor(employee.si_sumHoliday);//minutes
                        //console.log(this.summAll);


                       // console.log("******");
/*
                        // TODO - Krankenstand, Urlaube

                        // FTA Zeiten Plan actual month
                        this.summAll = this.summAll + employee.si_sumHolidayPlanned;//minutes

                        // FTA ZEITEN Monatsabschluss
                        this.summAll = this.summAll + employee.si_holidayTimeBalance;//minutes
*/
                        // IS RED OVERTIME VISIBLE?
                        this.red_overtime_width = 0;
                        if(this.summAll > this.weekTimeRegular){
                            this.red_overtime_width = (this.summAll - this.weekTimeRegular) * this.oneMinuteInPixel;
                        }

                        this.summAllWidth = this.summAll * this.oneMinuteInPixel;


                        this.availablePlantime = this.summAll - this.availablePlantime;
                        if(this.availablePlantime > -60 && this.availablePlantime < 60){
                            this.availablePlantimeInHours = Math.floor(this.availablePlantime / 60 * 100) / 100.0; // Show 2 decimals if within 60 minutes deviation
                        }else{
                            this.availablePlantimeInHours = Math.floor(this.availablePlantime / 60);
                        }

                    }
                }
            }
        },
        mounted() {
            //$('html').append(this.$el);
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .noContract{
        font-size: 13px;
        color: #e5154f;
        text-align: left;
        height: 15px;
        white-space: nowrap;
        font-weight: 800;
    }
</style>
